import QrCodeCardGrid from "../QrCodeCardGrid/QrCodeCardGrid";
import "./qrCodeList.css";
import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";

const QrCodeList = () => {
  return (
    <div className="profileDetails" role="main">
      <div className="qrCodeList__header">
        <div className="qrCodeList__header-left">
          <h1 className="qrCodeList__title">QR Codes</h1>
          <Breadcrumb className="overview__container__breadcrumbs">
            <Breadcrumb.Item href="/home">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/dashboard">Dashboard</Breadcrumb.Item>
            <Breadcrumb.Item active>QR Codes</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="qrCodeList__header-right">
          <Link to="create">
            <button className="qrCodeList__container__buttons__create-btn">
              <i className="fas fa-plus"></i> Create QR Code
            </button>
          </Link>
        </div>
      </div>
      <div className="qrCodeList__content">
        <QrCodeCardGrid />
      </div>
    </div>
  );
};

export default QrCodeList;
